module.exports = __webpack_public_path__ + "eea41d3da4ad0cc2c511f0825bb1db62.svg";